import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'

//vue-router
import router from './router'

//本地存储
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

//国际化 vue-i18n
import { i18n } from './setup/i18n-setup.js'

//svg库 fontawesome 
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookSquare, faTwitterSquare, faYoutubeSquare, faInstagramSquare, faFacebookF,  faTwitter, faLinkedin, faInstagram, faSteam, faWindows } from '@fortawesome/free-brands-svg-icons'
import { faCommentDots, faShareAltSquare, faUserCircle, faBriefcase, faGlobeAmericas, faChevronRight, faBars, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
library.add([faFacebookF, faTwitter, faLinkedin, faInstagram, faSteam, faWindows,
  faCommentDots, faShareAltSquare, faUserCircle, faBriefcase, faGlobeAmericas, faFacebookSquare, faTwitterSquare, faYoutubeSquare, faInstagramSquare, faChevronRight,
  faBars, faAngleLeft, faAngleRight])
Vue.component('font-awesome-icon', FontAwesomeIcon)

//vue组件库 BootstrapVue
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount('#app');
